const customFieldModules = {
  Orders: {
    value: 'ORDERS',
    label: 'customField.module.orders'
  },
  Users: {
    value: 'USERS',
    label: 'customField.module.users'
  },
  Drivers: {
    value: 'DRIVERS',
    label: 'customField.module.drivers'
  },
  Cars: {
    value: 'CARS',
    label: 'customField.module.cars'
  },
  Contractors: {
    value: 'CONTRACTORS',
    label: 'customField.module.contractors'
  },
  ContractorPolicies: {
    value: 'CONTRACTOR_POLICIES',
    label: 'customField.module.contractorPolicies'
  },
  FerryServices: {
    value: 'FERRY_SERVICES',
    label: 'customField.module.ferryServices'
  }
}
export default customFieldModules
